import { useEffect} from 'react';
import DefaultImg1 from '../../../images/categoryM_0001.png';
import DefaultImg2 from '../../../images/MyLogo.png';
import DefaultImg3 from '../../../images/categoryM_0003.png';
import DefaultImg4 from '../../../images/categoryM_0004.png';
import DefaultImg5 from '../../../images/categoryM_0002.png';
import DefaultImg6 from '../../../images/categoryTPC_0004.png';
import './style.css';


function SlideShowGalleryDetail(props) {
      useEffect(() => { // 폼로드와 비슷한 개념
        slideIndex=1;
        showSlides(slideIndex);
      }, []); 
      let slideIndex = 1;
    
 
    let showSlides=(n)=> {
    var i;
    var slides = document.getElementsByClassName("detailSlide");
    var dots = document.getElementsByClassName("detailDemo");
    var captionText = document.getElementById("detailCaption");

    if (n > slides.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slides.length}
    
    // for (i = 0; i < slides.length; i++) {
    //     slides[i].style.display = "none";
    // }
    // for (i = 0; i < dots.length; i++) {
    //     dots[i].className = dots[i].className.replace("GalleryActive", "");
    // }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
      dots[i].className = dots[i].className.replace(" GalleryActive", ""); // Remove the active class from all thumbnails
    }
  
    for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace("GalleryActive", "");
        // Reset opacity for all thumbnails
        dots[i].style.opacity= "0.6";
        
      }
    
      // Add the active class to the current thumbnail
      dots[slideIndex-1].className += " GalleryActive";
      
      // Set opacity to full for the current thumbnail
      dots[slideIndex-1].style.opacity= "1";
    
      slides[slideIndex-1].style.display = "block";
      captionText.innerHTML = dots[slideIndex-1].alt;
    }
    // Next/previous controls
    let plusSlides=(n)=> {
        showSlides(slideIndex += n);
    }
    let currentSlide=(n)=> {
        showSlides(slideIndex = n);
    }

    return (
  <div className="GalleryDetailContainer">

    {/* 슬라이드 */}
    <div className="detailSlide">
      <div className="numbertext">1</div>
      <img src={DefaultImg1}/>
    </div>

    <div className="detailSlide">
      <div className="numbertext">2</div>
      <img src={DefaultImg2}/>
    </div>

    <div className="detailSlide">
      <div className="numbertext">3</div>
      <img src={DefaultImg3}/>
    </div>

    <div className="detailSlide">
      <div className="numbertext">4</div>
      <img src={DefaultImg4}/>
    </div>

    <div className="detailSlide">
      <div className="numbertext">5</div>
      <img src={DefaultImg5}/>
    </div>

    <div className="detailSlide">
      <div className="numbertext">6</div>
      <img src={DefaultImg6}/>
    </div>

    <a className="prev" onClick={()=>plusSlides(-1)}>&#10094;</a>
    <a className="next" onClick={()=>plusSlides(1)}>&#10095;</a>

    <div className="detailCaption-container">
      <span id="detailCaption"></span>
    </div>

      {/* 썸네일 슬라이드 */}
    <div className="row">
      <div className="column">
        <img className="detailDemo cursor" src={DefaultImg1}  onClick={()=>currentSlide(1)} alt=""/>
      </div>
      <div className="column">
        <img className="detailDemo cursor" src={DefaultImg2}  onClick={()=>currentSlide(2)} alt=""/>
      </div>
      <div className="column">
        <img className="detailDemo cursor" src={DefaultImg3}  onClick={()=>currentSlide(3)} alt=""/>
      </div>
      <div className="column">
        <img className="detailDemo cursor" src={DefaultImg4} onClick={()=>currentSlide(4)} alt=""/>
      </div>
      <div className="column">
        <img className="detailDemo cursor" src={DefaultImg5}  onClick={()=>currentSlide(5)} alt=""/>
      </div>
      <div className="column">
        <img className="detailDemo cursor" src={DefaultImg6} onClick={()=>currentSlide(6)} alt=""/>
      </div>
    </div>
  </div>
  );
}
  
  export default SlideShowGalleryDetail;